import type { AssetFile } from '@main/pc-types';
import { withIds } from '@main/schema-utils';

/**
 * Image for the organization logo
 */
export const ACME_ORG = withIds<AssetFile>({
  id: 'default-log-asset',
  key: 'privacy-v1/ACME.svg',
  src: 'https://transcend-testing-assets.s3-us-west-1.amazonaws.com/transcend/logo.svg',
  mimetype: 'image/svg',
  size: 3163,
});
